var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './RecommendedActionTemplates.scss';
import { ActionTemplateCard } from './ActionTemplateCard';
import { createAsyncSelectors } from '@lib/selectors';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { Alert, Button, Flex, Row } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { coreActions, FeatureFlag, getRecommendedActionTemplateById, postRecommendedActionTemplateByUrl, RecommendedActionTemplateType } from '@sonar-software/sonar-core';
import { Link, useNavigate } from 'react-router-dom';
import React, { useCallback } from 'react';
import { useAction, useAppNotifications, useAsyncState, useFeatureFlag, useOnMount } from '@hooks';
const selectors = createAsyncSelectors((state) => state.core.dataSecurity.actionTemplates.get);
function getTemplateDetails(templateId) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield getRecommendedActionTemplateById({
            templateId
        });
        return result.data;
    });
}
;
function postRecommendedActionTemplate(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield postRecommendedActionTemplateByUrl({ url });
        return result.data;
    });
}
;
export const RecommendedActionTemplates = ({ onClick }) => {
    const isEnabled = useFeatureFlag(FeatureFlag.RecommendedActionTemplates);
    const load = useAction(coreActions.requestGetCoreDataSecurityActionTemplates);
    const requestFollowed = useAction(coreActions.requestGetCoreFollowedAll);
    const navigate = useNavigate();
    const { errorNotification, successNotification } = useAppNotifications();
    const { data, isRequested } = useAsyncState(selectors);
    useOnMount(() => {
        if (isEnabled) {
            load();
        }
    });
    const handleOnClick = useCallback((templateId) => __awaiter(void 0, void 0, void 0, function* () {
        const templateDetails = yield getTemplateDetails(templateId);
        if (!templateDetails) {
            return;
        }
        ;
        if (templateDetails.type === RecommendedActionTemplateType.Monitor) {
            onClick(templateDetails);
            return;
        }
        if (templateDetails === null || templateDetails === void 0 ? void 0 : templateDetails.configuration.actionConfig) {
            const response = yield postRecommendedActionTemplate(templateDetails.configuration.actionConfig);
            if (response) {
                requestFollowed();
                navigate(`${FULL_ROUTES.DATA_DICTIONARY}/${response.url}`);
                successNotification(COPY_SPECIFIC.SENSITIVE_FIELDS_FOLLOWED_MESSAGE(response.fieldCount), {
                    message: COPY_SPECIFIC.SENSITIVE_FIELDS_FOLLOWED
                });
                return;
            }
        }
        errorNotification(COPY_GENERIC.CONTACT_SUPPORT);
    }), [errorNotification, navigate, onClick, requestFollowed, successNotification]);
    if (!isEnabled) {
        return null;
    }
    return (React.createElement("div", { className: 'recommended-action-templates-section' },
        React.createElement("div", { className: 'h2 title' }, COPY_SPECIFIC.RECOMMENDED_ACTION_TEMPLATES),
        React.createElement(Alert, { closable: true, message: React.createElement(Flex, { justify: 'space-between' },
                COPY_SPECIFIC.SETUP_CRITICAL_APPLICATIONS_MESSAGE,
                React.createElement(Link, { to: FULL_ROUTES.DATA_SECURITY_APPLICATION_SETUP },
                    React.createElement(Button, { size: 'small', type: 'primary' }, COPY_SPECIFIC.SETUP_CRITICAL_APPLICATIONS))), showIcon: true, type: 'info' }),
        React.createElement(LoadingSpinner, { spinning: isRequested },
            React.createElement(Row, { className: 'recommended-action-templates', wrap: true }, data === null || data === void 0 ? void 0 : data.map((entry) => React.createElement(ActionTemplateCard, Object.assign({ key: entry.id, onClick: handleOnClick }, entry)))))));
};
